module.exports = __webpack_public_path__ + "img/square_w.1956fd36.svg";